import { apiClient } from "./apiClient";

import type {
  BrandDetailsData,
  BrandItemData,
  BrandsListData,
  BrandsQuery,
  CreateBrandInput,
  DeleteBrandData,
  UpdateBrandInput,
} from "../types/brands.types";

function buildBrandsQuery(query: BrandsQuery = {}): string {
  const params = new URLSearchParams();

  if (query.search?.trim()) {
    params.set("search", query.search.trim());
  }

  if (query.isActive !== undefined) {
    params.set(
      "isActive",
      String(query.isActive),
    );
  }

  if (query.sort) {
    params.set("sort", query.sort);
  }

  if (query.cursor?.trim()) {
    params.set("cursor", query.cursor.trim());
  }

  if (query.limit !== undefined) {
    params.set("limit", String(query.limit));
  }

  const queryString = params.toString();

  return queryString
    ? `/brands?${queryString}`
    : "/brands";
}

export const brandsApi = {
  list(query: BrandsQuery = {}) {
    return apiClient.get<BrandsListData>(
      buildBrandsQuery(query),
    );
  },

  getById(brandId: string) {
    return apiClient.get<BrandDetailsData>(
      `/brands/${encodeURIComponent(brandId)}`,
    );
  },

  create(input: CreateBrandInput) {
    return apiClient.post<BrandItemData>(
      "/brands",
      input,
    );
  },

  update(
    brandId: string,
    input: UpdateBrandInput,
  ) {
    return apiClient.patch<BrandItemData>(
      `/brands/${encodeURIComponent(brandId)}`,
      input,
    );
  },

  delete(brandId: string) {
    return apiClient.delete<DeleteBrandData>(
      `/brands/${encodeURIComponent(brandId)}`,
    );
  },
};